import { render, staticRenderFns } from "./EtabAlimConfiance.vue?vue&type=template&id=a4d49bf0"
import script from "./EtabAlimConfiance.vue?vue&type=script&lang=js"
export * from "./EtabAlimConfiance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports